// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Text from 'components/Form/Text'
import Select from 'components/Form/Select'
import Checkbox from 'components/Form/Checkbox'

// Redux:
import { setProgramsFilterSearch, setProgramsFilterCategory, setProgramsFilterPodcasts } from 'actions/programs'

class ProgramsFilters extends React.Component {
	constructor() {
		super()

		this.state = {
			advanced: false
		}
	}

	handleSearchChange = ( id, value ) => {
		const { dispatch } = this.props

		dispatch( setProgramsFilterSearch( value ) )
	}

	handleCatChange = ( id, value ) => {
		const { dispatch } = this.props

		dispatch( setProgramsFilterCategory( value ) )
	}

	handlePodcastsChange = ( id, value ) => {
		const { dispatch } = this.props

		dispatch( setProgramsFilterPodcasts( value ) )
	}

	render() {
		const { filterSearch, filterCategory, categoriesById, filterPodcasts, isPodcasts } = this.props
		let categories = [ {
			name: 'Any',
			value: ''
		} ]

		if ( categoriesById && Object.keys( categoriesById ).length ) {
			Object.keys( categoriesById ).forEach( i => {
				categories.push({
					name: categoriesById[ i ].title,
					value: categoriesById[ i ].slug
				})
			})
		}

		return (
			<div className="program-filters">
				<div className="-inner">
					<div className="-filters">
						<Text
							id="search"
							label="Search by Name"
							value={ filterSearch }
							onChange={ this.handleSearchChange }
						/>

						<Select
							id="category"
							label="Category"
							value={ filterCategory }
							options={ categories }
							onChange={ this.handleCatChange }
						/>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		programsById: state.programs.byId,
		categoriesById: state.programs.categoriesById,
		filterSearch: state.programs.filterSearch,
		filterCategory: state.programs.filterCategory,
		filterPodcasts: state.programs.filterPodcasts
	}
}

export default connect( mapStateToProps )( ProgramsFilters )
